/**
 * Tracks whether the app is currently redirecting due to an authentication
 * failure (expired/invalid token). When true, error toasts are suppressed
 * to prevent a flood of error messages during the redirect to Auth0 logout.
 */
let _isAuthRedirecting = false

export const setAuthRedirecting = () => {
  _isAuthRedirecting = true
}

export const isAuthRedirecting = () => _isAuthRedirecting
